import { Box, Stack, Typography } from "@mui/material";
import BuildIcon from "@mui/icons-material/Build";
import { useThemeMode } from "../../../theme/ThemeModeProvider";
import { chatRailTokens } from "../tokens";
import { renderSkillResult } from "./toolRenderers/registry";

interface ToolCallCardProps {
  kind: "invocation" | "result";
  skillName: string;
  input: unknown;
  onOpenRun?: () => void;
}

export function ToolCallCard({ kind, skillName, input, onOpenRun }: ToolCallCardProps) {
  const { mode } = useThemeMode();
  const T = chatRailTokens(mode);

  const rendered = renderSkillResult(skillName, kind, input, T);

  return (
    <Box
      sx={{
        bgcolor: T.panel,
        border: `1px solid ${T.hair}`,
        borderRadius: `${T.r_sm}px`,
        p: 1,
        fontFamily: T.sans,
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center" mb={0.5}>
        <BuildIcon sx={{ fontSize: 12, color: T.textMute }} />
        <Typography
          sx={{
            fontFamily: T.mono,
            fontSize: T.fs_micro,
            color: T.textDim,
            flex: 1,
          }}
        >
          {kind === "invocation" ? "→" : "←"} {skillName}
        </Typography>
        {onOpenRun && (
          <Box
            component="button"
            type="button"
            onClick={onOpenRun}
            sx={{
              border: "none",
              bgcolor: "transparent",
              cursor: "pointer",
              color: T.accent,
              fontSize: T.fs_micro,
              p: 0,
              "&:hover": { textDecoration: "underline" },
            }}
          >
            details
          </Box>
        )}
      </Stack>
      {rendered}
    </Box>
  );
}
